import {Component, OnInit} from '@angular/core';
import {MdbModalRef, MdbModalService} from 'mdb-angular-ui-kit/modal';
import {ToastrService} from 'ngx-toastr';
import {TokenStorageService} from '../../services/storage/token-storage.service';
import {UserService} from '../../services/user.service';
import {MdbTabChange} from "mdb-angular-ui-kit/tabs/tabs.component";

@Component({
    selector: 'app-pending-request',
    templateUrl: './pending-request-page.component.html',
    styleUrls: ['./pending-request-page.component.css'],
    standalone: false
})
export class PendingRequestComponent implements OnInit {

  pendingRequestsResponse: any;
  pendingRequestData: any;
  pendingInternalUserRequestsResponse: any;
  pendingInternalUserRequestData: any;
  pa: number = 1;
  itemsPerPage: number = 10;
  loading: boolean = false;
  approveModalRef: MdbModalRef<ApproveRequestModalComponent> | null = null;
  viewModalRef: MdbModalRef<PendingUserDetailsModalComponent> | null = null;
  initialLoading: boolean = false;
  institutions: any;
  difcInstitutions:any;
  isPendingRequestShow: boolean = true;
  filterText = "";
  selectedFilter = 'fullName';
  filters = [

    {name: 'Full Name', value: 'fullName'},
    {name: 'Email', value: 'email'},
    {name: 'Contact No', value: 'contactNo'},
    {name: 'Username', value: 'username'},
    {name: 'Company', value: 'company'}

  ];

  filtersForInternalUsers = [

    {name: 'Full Name', value: 'fullName'},
    {name: 'Email', value: 'email'},
    {name: 'Contact No', value: 'contactNo'},
    {name: 'Username', value: 'username'}
  ];
  filtersforNormalBrokers = [
    {name: 'Username', value: 'username'},
    {name: 'Full Name', value: 'fullName'},
    {name: 'Email', value: 'email'},
    {name: 'Contact No', value: 'contactNo'},
    {name: 'Company', value: 'company'}
  ];

  sortOrder = "ascending";
  sortBy = "";
  role:any;
  openAPIEnabled : any;
  embedAPIEnabled : any;
  backOfficeAPIEnabled : any;
  dwmAPIEnabled : any;
  feedAPIEnabled : any;


  constructor(private userService: UserService, private toastr: ToastrService,
              private modalService: MdbModalService, private tokenStorageService: TokenStorageService) {
    this.role = this.tokenStorageService.getUser().role;

  }

  ngOnInit(): void {
    this.loadPage(1,1);
    this.institutionList();
  }

  pageChanged(event: any): void {
    this.pa = event;
    this.loadDetails(1, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

  }

  pageSizeChanged(entires: number): void {
    this.itemsPerPage = entires;
    this.loadDetails(1, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

  }

  approveBroker(broker: any, userRole:any) {
    this.approveModalRef = this.modalService.open(ApproveRequestModalComponent, {
      modalClass: 'modal-dialog-centered',
      data: {
        id: broker.id,
        firstName: broker.firstName,
        lastName: broker.lastName,
        company: broker.company,
        email: broker.email,
        contactNo: broker.contactNo,
        profession: broker.profession,
        institutions: this.institutions,
        difcInstitutions: this.difcInstitutions,
        username: broker.username,
        userrole:userRole
      }
    });
    this.approveModalRef.onClose.subscribe((message: any) => {
      this.loadPage(1,1);
    });
  }

  approveInternalUser(broker: any, userRole:any) {
    this.approveModalRef = this.modalService.open(ApproveRequestModalComponent, {
      modalClass: 'modal-dialog-centered',
      data: {
        id: broker.id,
        firstName: broker.firstName,
        lastName: broker.lastName,
        company: broker.company,
        email: broker.email,
        contactNo: broker.contactNo,
        profession: broker.profession,
        institutions: this.institutions,
        difcInstitutions: this.difcInstitutions,
        username: broker.username,
        userrole:userRole
      }
    });

    this.approveModalRef.onClose.subscribe((message: any) => {
      this.loadPage(5,1);
    });
  }

  viewBroker(broker: any) {
    this.viewModalRef = this.modalService.open(PendingUserDetailsModalComponent, {
      modalClass: 'modal-dialog-centered modal-lg',
      data: {
        firstName: broker.firstName,
        lastName: broker.lastName,
        company: broker.company,
        email: broker.email,
        contactNo: broker.contactNo,
        profession: broker.profession,
        username: broker.username,
        abc:broker.role,
        openAPIEnabled:broker.openAPIEnabled,
        embedAPIEnabled:broker.embedAPIEnabled,
        dwmAPIEnabled:broker.dwmAPIEnabled,
        backOfficeAPIEnabled:broker.backOfficeAPIEnabled,
        feedAPIEnabled:broker.feedAPIEnabled
      }
    });
  }

  institutionList() {
    this.initialLoading = true;
    this.userService.getInstitutionList().subscribe((data: any) => {
      this.institutions = data.institutionList.sort((a: any, b: any) =>
        a.institution > b.institution ? 1 : -1
      );
      this.initialLoading = false;
    });
  }

  onRejectPress(brokerId: any, username: any) {
    this.loading = true;
    this.userService.rejectPendingBrokerUser(brokerId).subscribe(

      {
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {
            this.loadPage(1,1);
            this.toastr.success("Broker rejected successfully");
            localStorage.removeItem(username);

          } else {

            this.toastr.error(data.reason, "Failed to reject user");
          }
        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, "Failed to reject user");
        }
      }
    );
  }

  onInternalUserRejectPress(brokerId: any, username: any) {
    this.loading = true;
    this.userService.rejectPendingBrokerUser(brokerId).subscribe(

      {
        next: (data) => {
          this.loading = false;
          if (data.status == 'SUCCESS') {
            this.loadPage(5,1);
            this.toastr.success("Internal User rejected successfully");
            localStorage.removeItem(username);

          } else {

            this.toastr.error(data.reason, "Failed to reject user");
          }
        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, "Failed to reject user");
        }
      }
    );
  }


  initPendingInternalUserRequestData(data: any) {
    this.institutionList();
    var tempData: any = [];
    data.list.forEach((element: any) => {

      var temp = {

        id: element.id,

        firstName: element.firstName,
        lastName: element.lastName,
        fullName: element.firstName + " " + element.lastName,
        email: element.email,

        contactNo: element.contactNo,

        countryId: element.countryId,
        profession: element.profession,
        company: element.company,
        username: element.username,
        // region: element.region,
        requestDate: element.requestDate===null ? 'null': element.requestDate,
        userRole:element.role

      }
      tempData.push(temp)
    });
    return tempData
  }

  initPendingRequestData(data: any) {
    this.institutionList();
    var tempData: any = [];

    data.list.forEach((element: any) => {

      var temp = {

        id: element.id,
        firstName: element.firstName,
        lastName: element.lastName,
        fullName: element.firstName + " " + element.lastName,
        email: element.email,
        contactNo: element.contactNo,
        countryId: element.countryId,
        profession: element.profession,
        company: element.company,
        username: element.username,
        requestDate: element.requestDate===null ? 'null': element.requestDate,
        userRole:element.role,
        openAPIEnabled:element.openAPIEnabled,
        embedAPIEnabled:element.embedAPIEnabled,
        dwmAPIEnabled:element.dwmAPIEnabled,
        backOfficeAPIEnabled:element.backOfficeAPIEnabled,
        feedAPIEnabled:element.feedAPIEnabled

      }
      tempData.push(temp)
    });
    return tempData
  }

  loadPage(userType: number, pageNo: number): void {
    this.loading = true;
    this.userService.getSortedFilteredPendingUsersDetails(userType,'','','','', pageNo, this.itemsPerPage).subscribe(


        {
        next: (data) => {
          this.loading = false;

          if (data.status == 'SUCCESS') {

            if (userType === 1) {
              this.pendingRequestsResponse = data;
              this.pendingRequestData = this.initPendingRequestData(data)
              if (this.pendingRequestsResponse.list.length <= 0) {

                this.isPendingRequestShow = false;
              }
            }else if (userType === 5) {
              this.pendingInternalUserRequestsResponse = data;
              this.pendingInternalUserRequestData = this.initPendingRequestData(data)
              if (this.pendingInternalUserRequestsResponse.list.length <= 0) {

                this.isPendingRequestShow = false;
              }
            }

          } else {

            this.toastr.error(data.reason, "Failed to load data");
          }

        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, "Failed to load data");
        }
      }
    );
  }

  toggleSortDirection() {
    this.sortOrder = this.sortOrder === 'ascending' ? 'descending' : 'ascending';
    return this.sortOrder;
  }
  loadDetails(userType: number,pageNo: number, filter:string, filterText:string, sortOrder:string, sortBy:string): void {
    this.loading = true;
    this.userService.getSortedFilteredPendingUsersDetails(userType,sortOrder,sortBy,filter,filterText, pageNo, this.itemsPerPage).subscribe(
      {
        next: (data) => {
          this.loading = false;

          if (data.status == 'SUCCESS') {
            if (userType === 1) {
              this.pendingRequestsResponse = data;
              this.pendingRequestData = this.initPendingRequestData(data)
              if (this.pendingRequestsResponse.list.length <= 0) {

                this.isPendingRequestShow = false;
              }
            }else if (userType === 5) {
              this.pendingInternalUserRequestsResponse = data;
              this.pendingInternalUserRequestData = this.initPendingRequestData(data)
              if (this.pendingInternalUserRequestsResponse.list.length <= 0) {

                this.isPendingRequestShow = false;
              }
            }


          } else {

            this.toastr.error(data.reason, "Failed to load data");
          }

        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, "Failed to load data");
        }
      }
    );
  }

  // loadBrokers(userType: number,pageNo: number, filter:string, filterText:string, sortOrder:string, sortBy:string): void {
  //   this.loading = true;
  //   this.userService.getSortedFilteredPendingUsersDetails(1,sortOrder,sortBy,filter,filterText, pageNo, this.itemsPerPage).subscribe(
  //     {
  //       next: (data) => {
  //         this.loading = false;
  //
  //         if (data.status == 'SUCCESS') {
  //             this.pendingRequestsResponse = data;
  //             this.pendingRequestData = this.initPendingRequestData(data)
  //             if (this.pendingRequestsResponse.list.length <= 0) {
  //
  //               this.isPendingRequestShow = false;
  //             }
  //
  //         } else {
  //
  //           this.toastr.error(data.reason, "Failed to load data");
  //         }
  //
  //       },
  //       error: (err) => {
  //         this.loading = false;
  //         this.toastr.error(err.error.message, "Failed to load data");
  //       }
  //     }
  //   );
  // }
  pageSizeChangedForInternalUser(entries: number): void {
    this.itemsPerPage = entries;
    this.loadDetails(5, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

  }
  pageChangedForInternalUser(event: any): void {
    this.pa = event;
    this.loadDetails(5, this.pa, this.selectedFilter, this.filterText, this.sortOrder, this.sortBy);

  }

  getAdminPendingUserList(event: MdbTabChange) {
    if (event.index === 0) {
      this.loadPage(1, this.pa);
    }
    else if (event.index === 1) {
      this.loadPage(5, this.pa);
    }
  }


}

@Component({
    selector: 'approve-request-modal',
    templateUrl: 'approve-request-page-modal.html',
    styleUrls: ['./pending-request-page.component.css'],
    standalone: false
})
export class ApproveRequestModalComponent {

  id: number = -1;
  firstName: string | null = null;
  lastName: string | null = null;
  company: string | null = null;
  contactNo: string | null = null;
  email: string | null = null;
  profession: string | null = null;
  institutions: any | null = null;
  difcInstitutions:any | null = null;
  username: string | null = null;
  institutionId: number = -1;
  submitted: boolean = false;
  loading: boolean = false;
  user: any;
  region: string = '';
  isDisabled: boolean= true;
  selectedRole:any;
  userrole:any;
  openAPIEnabled : any;
  embedAPIEnabled : any;
  backOfficeAPIEnabled : any;
  dwmAPIEnabled : any;
  feedAPIEnabled : any;


  constructor(public modalRef: MdbModalRef<ApproveRequestModalComponent>, private toastr: ToastrService,
              private userService: UserService, private tokenStorage: TokenStorageService) {
  }

  ngOnInit(): void {
    this.user = this.tokenStorage.getUser();

    if (this.userrole === 5) {
      this.selectedRole = 'internalUser';
    }
  }

  onUserAprrove(): void {
    this.submitted = true;
    if (this.institutionId !== -1) {
      this.userService.approveBrokerUser(
        this.selectedRole,
        this.id,
        this.user.username,
        this.institutionId,
        this.region,
        this.openAPIEnabled== true ? 1 : 0,
        this.embedAPIEnabled == true ? 1 : 0,
        this.backOfficeAPIEnabled == true ? 1 : 0,
        this.dwmAPIEnabled == true ? 1 : 0,
        this.feedAPIEnabled == true ? 1 : 0
        ).subscribe(
        {
          next: (data) => {
            this.loading = false;
            if (data.status == 'SUCCESS') {
              this.closeModal();
              this.toastr.success("Broker approved successfully");
            } else {

              this.toastr.error(data.reason, "Failed to approve Broker user");
            }
          },
          error: (err) => {
            this.loading = false;
            this.toastr.error(err.error.message, "Failed to approve  Broker user");
          }
        }
      );
    }
  }

  closeModal(): void {
    this.modalRef.close();
  }


  enableInstitutionSelectBox(event :any) {
    this.isDisabled = false;
  }

}

@Component({
    selector: 'pending-user-details-modal',
    templateUrl: 'pending-user-details-modal.html',
    styleUrls: ['./pending-request-page.component.css'],
    standalone: false
})
export class PendingUserDetailsModalComponent {

  firstName: string | null = null;
  lastName: string | null = null;
  company: string | null = null;
  email: string | null = null;
  contactNo: string | null = null;
  profession: string | null = null;
  username: string | null = null;
  openAPIEnabled : any;
  embedAPIEnabled : any;
  backOfficeAPIEnabled : any;
  dwmAPIEnabled : any;
  feedAPIEnabled : any;
  constructor(public modalRef: MdbModalRef<PendingUserDetailsModalComponent>) {
  }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.modalRef.close();
  }

}
